import { render, staticRenderFns } from "./ProductionPersonalPerformance.vue?vue&type=template&id=5191c671&scoped=true"
import script from "./ProductionPersonalPerformance.vue?vue&type=script&lang=js"
export * from "./ProductionPersonalPerformance.vue?vue&type=script&lang=js"
import style0 from "./ProductionPersonalPerformance.vue?vue&type=style&index=0&id=5191c671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5191c671",
  null
  
)

export default component.exports